import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function FlashOff({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M22.6666 12C22.6666 14.2228 21.9867 16.2867 20.8236 17.9953C20.5709 18.3665 20.2954 18.7208 19.9991 19.0564L21.8047 20.8619L20.8618 21.8047L2.19518 3.13808L3.13799 2.19527L4.94352 4.0008C5.2791 3.70456 5.63352 3.42909 6.00475 3.17641C7.69809 2.02363 9.74048 1.34548 11.9406 1.3335L11.9739 1.33337L11.9999 1.33334C17.891 1.33334 22.6666 6.10897 22.6666 12ZM19.8613 17.033C20.6802 15.7566 21.1967 14.2678 21.3097 12.6675C21.3253 12.4471 21.3333 12.2245 21.3333 12C21.3333 6.84535 17.1546 2.66668 11.9999 2.66668L11.9782 2.6667C11.8841 2.66692 11.7904 2.66852 11.697 2.6715C9.95834 2.72694 8.33973 3.2579 6.96694 4.1386C6.58786 4.38184 6.22741 4.65168 5.8884 4.94568L10.3191 9.37642L14.6666 4.66668L12.6666 10H17.3333L14.2658 13.3231L19.0542 18.1115C19.3482 17.7725 19.6181 17.4121 19.8613 17.033Z"
        fill={iconColor}
      />
      <Path
        d="M2.66659 12C2.66659 10.1465 3.20686 8.41924 4.13851 6.96703L3.17625 6.00477C2.01312 7.71332 1.33325 9.77727 1.33325 12C1.33325 17.891 6.10888 22.6667 11.9999 22.6667C14.2227 22.6667 16.2866 21.9868 17.9952 20.8237L17.0329 19.8614C15.5807 20.7931 13.8534 21.3333 11.9999 21.3333C6.84526 21.3333 2.66659 17.1547 2.66659 12Z"
        fill={iconColor}
      />
      <Path
        d="M10.5048 13.3333L8.50894 11.3375L6.66659 13.3333H10.5048Z"
        fill={iconColor}
      />
      <Path
        d="M12.4556 15.2841L11.1073 13.9358L9.33325 18.6667L12.4556 15.2841Z"
        fill={iconColor}
      />
    </Svg>
  );
}
